<div class="statement-action-wrapper" [ngStyle]="{'min-width': mode === 'statementTracker' ? '130px' : '100px'}"
     dstClickOutside [clickOutsideEnabled]="!!(rowData.showDropdown || rowData.showExtendedMenu)" (clickOutside)="rowData.showDropdown = false; rowData.showExtendedMenu = false;">
  @if (mode === 'statementTracker') {
<span class="Appkit4-icon hover-o" [ngClass]="getReviewClassName()"
        [ngStyle]="{'color': (rowData.isReviewedVal) ? ' green' : ' red', 'pointer-events': rowData.ignoredId !== 0 || rowData.statementId === '0' ? 'none' : 'unset'}"
        (click)="onToggleReview()">
  </span>
}
  <span class="hover-o" [ngStyle]="{'pointer-events': rowData.ignoredId && rowData.ignoredId !== 0 ? 'none' : 'unset'}"
        (click)="showViewUpdate()">{{getCreateBtnText()}}</span>
  <div class="st-dropdown-button">
    <span class="hover-o a-icon Appkit4-icon icon-down-chevron-fill" getMenuPos [menuPosMode]="'fixed'"
          (menuClick)="showDropdown($event, rowData)"></span>
    <!-- Hide below sub componenet when grid has stmt id column freezed (ex: stmt trck) for dropdown hidding Issue fix (see stmt trck html for sub component addition)-->
    @if (mode !== 'statementTracker' && rowData.showDropdown) {
<dst-dropdown-menu [rowObject]="rowData" [mode]="mode" [menuPos]="menuPos"
                       (taggingProject)="onTaggingProject()" (copyReplicate)="onCopyReplicate($event)"
                       (showUnmatchConfirm)="onShowUnmatchConfirm()" (showDeleteConfirm)="onShowDeleteConfirm()"
                       (matchTracker)="onMatchTracker()" (saveSuccess)="onSaveSuccess()">
    </dst-dropdown-menu>
}
    @if (mode !== 'statementTracker' && rowData.showExtendedMenu) {
<dst-mark-as-template (showMarkOtherReason)="onShowMarkOtherReason()" [rowObject]="rowData"
                        [markAsOptions]="markAsOptions" [menuPos]="menuPos"></dst-mark-as-template>
}
  </div>
</div>
